module.exports = () => {
  const utmParams = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];

  const urlParams = new URLSearchParams(window.location.search);

  const utmParamsObject = {};

  utmParams.forEach((param) => {
    if (urlParams.has(param))
      utmParamsObject[param.replace("utm_", "")] = urlParams.get(param);
  });

  if (Object.keys(utmParamsObject).length) return utmParamsObject;

  const sessionStorageUtmParams = sessionStorage.getItem("utm");
  if (sessionStorageUtmParams) return JSON.parse(sessionStorageUtmParams);

  return null;
};
